import React from 'react';
import "./allUi.css";

function Card({ className = '', ...props }) {
  return (
    <div
      data-slot="card"
      className={`newdashboard-card ${className}`}
      {...props}
    />
  )
}

function CardHeader({ className = '', ...props }) {
  return (
    <div
      data-slot="card-header"
      className={`newdashboard-card-header ${className}`}
      {...props}
    />
  )
}

function CardTitle({ className = '', ...props }) {
  return (
    <div
      data-slot="card-title"
      className={`newdashboard-card-title ${className}`}
      {...props}
    />
  )
}

function CardDescription({ className = '', ...props }) {
  return (
    <div
      data-slot="card-description"
      className={`newdashboard-card-description ${className}`}
      {...props}
    />
  )
}

function CardAction({ className = '', ...props }) {
  return (
    <div
      data-slot="card-action"
      className={`newdashboard-card-action ${className}`}
      {...props}
    />
  )
}

function CardContent({ className = '', ...props }) {
  return (
    <div
      data-slot="card-content"
      className={`newdashboard-card-content ${className}`}
      {...props}
    />
  )
}

function CardFooter({ className = '', ...props }) {
  return (
    <div
      data-slot="card-footer"
      className={`newdashboard-card-footer ${className}`}
      {...props}
    />
  )
}

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
};